/* Cargauge vehicle finder, My Garage and "fits your vehicle" badge.
   Vehicle data comes from /pages/vehicle-data (template page.vehicle-data, Vehicle metaobjects).
   The selected vehicle is stored in this browser only (localStorage). */
(function () {
  'use strict';
  var GARAGE_KEY = 'cg_garage_v1';
  var DATA_KEY = 'cg_vehicles_v1';
  var DATA_TTL = 60 * 60 * 1000;
  var DATA_URL = (window.cgFitment && window.cgFitment.dataUrl) || '/pages/vehicle-data';
  var MAX_GARAGE = 5;
  var vehicles = null;

  function readJSON(store, key) {
    try { return JSON.parse(store.getItem(key)); } catch (e) { return null; }
  }
  function writeJSON(store, key, val) {
    try { store.setItem(key, JSON.stringify(val)); } catch (e) {}
  }

  /* ---------- garage ---------- */
  function getGarage() {
    var g = readJSON(window.localStorage, GARAGE_KEY);
    if (!g || !Array.isArray(g.vehicles)) g = { active: 0, vehicles: [] };
    if (g.active >= g.vehicles.length) g.active = 0;
    return g;
  }
  function saveGarage(g) {
    writeJSON(window.localStorage, GARAGE_KEY, g);
    document.dispatchEvent(new CustomEvent('cg:garage-change'));
  }
  function label(v) { return v.year + ' ' + v.make + ' ' + v.model; }
  function activeVehicle() {
    var g = getGarage();
    return g.vehicles[g.active] || null;
  }
  function addVehicle(v) {
    var g = getGarage();
    var key = label(v).toLowerCase();
    g.vehicles = g.vehicles.filter(function (x) { return label(x).toLowerCase() !== key; });
    g.vehicles.unshift(v);
    g.vehicles = g.vehicles.slice(0, MAX_GARAGE);
    g.active = 0;
    saveGarage(g);
  }

  /* ---------- vehicle data ---------- */
  function fetchPage(page) {
    return fetch(DATA_URL + '?page=' + page, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }
  function loadVehicles() {
    if (vehicles) return Promise.resolve(vehicles);
    var cached = readJSON(window.sessionStorage, DATA_KEY);
    if (cached && cached.t && Date.now() - cached.t < DATA_TTL) {
      vehicles = cached.v;
      return Promise.resolve(vehicles);
    }
    var all = [];
    function next(page) {
      return fetchPage(page).then(function (d) {
        all = all.concat(d.vehicles || []);
        if (page < (d.pages || 1) && page < 50) return next(page + 1);
      });
    }
    return next(1).then(function () {
      vehicles = all.filter(function (v) { return v.make && v.model && v.from; });
      writeJSON(window.sessionStorage, DATA_KEY, { t: Date.now(), v: vehicles });
      return vehicles;
    });
  }
  function inRange(v, year) { return year >= v.from && year <= (v.to || v.from); }
  function unique(arr) { return arr.filter(function (x, i) { return arr.indexOf(x) === i; }); }

  /* ---------- finder UI ---------- */
  function fill(select, placeholder, values) {
    select.innerHTML = '';
    var o = document.createElement('option');
    o.value = ''; o.textContent = placeholder;
    select.appendChild(o);
    values.forEach(function (val) {
      var opt = document.createElement('option');
      opt.value = val; opt.textContent = val;
      select.appendChild(opt);
    });
    select.disabled = values.length === 0;
  }

  function initFinder(root) {
    var year = root.querySelector('[data-cg-year]');
    var make = root.querySelector('[data-cg-make]');
    var model = root.querySelector('[data-cg-model]');
    var go = root.querySelector('[data-cg-go]');
    var form = root.querySelector('[data-cg-form]');
    var err = root.querySelector('[data-cg-error]');

    function years() {
      var ys = [];
      vehicles.forEach(function (v) { for (var y = v.from; y <= (v.to || v.from); y++) ys.push(y); });
      return unique(ys).sort(function (a, b) { return b - a; }).map(String);
    }
    function onYear() {
      var y = parseInt(year.value, 10);
      fill(model, 'Model', []); go.disabled = true;
      if (!y) { fill(make, 'Make', []); return; }
      var makes = unique(vehicles.filter(function (v) { return inRange(v, y); })
        .map(function (v) { return v.make; })).sort();
      fill(make, 'Make', makes);
    }
    function onMake() {
      var y = parseInt(year.value, 10);
      go.disabled = true;
      if (!make.value) { fill(model, 'Model', []); return; }
      var models = unique(vehicles.filter(function (v) { return v.make === make.value && inRange(v, y); })
        .map(function (v) { return v.model; })).sort();
      fill(model, 'Model', models);
    }
    year.addEventListener('change', onYear);
    make.addEventListener('change', onMake);
    model.addEventListener('change', function () { go.disabled = !model.value; });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!year.value || !make.value || !model.value) return;
      addVehicle({ year: parseInt(year.value, 10), make: make.value, model: model.value });
      var url = root.getAttribute('data-results-url');
      var onProduct = document.querySelector('[data-cg-fit]');
      if (url && !onProduct) window.location.href = url;
    });

    loadVehicles().then(function () {
      fill(year, 'Year', years());
      fill(make, 'Make', []);
      fill(model, 'Model', []);
    }).catch(function () { if (err) err.hidden = false; });

    initGarage(root);
  }

  function initGarage(root) {
    var box = root.querySelector('[data-cg-garage]');
    if (!box) return;
    var toggle = box.querySelector('[data-cg-garage-toggle]');
    var list = box.querySelector('[data-cg-garage-list]');
    var lab = box.querySelector('[data-cg-garage-label]');

    function render() {
      var g = getGarage();
      list.innerHTML = '';
      box.hidden = g.vehicles.length === 0;
      if (!g.vehicles.length) return;
      lab.textContent = 'My Garage: ' + label(g.vehicles[g.active]);
      g.vehicles.forEach(function (v, i) {
        var li = document.createElement('li');
        var pick = document.createElement('button');
        pick.type = 'button';
        pick.textContent = label(v) + (i === g.active ? ' \u2713' : '');
        pick.addEventListener('click', function () {
          var gg = getGarage(); gg.active = i; saveGarage(gg);
        });
        var rm = document.createElement('button');
        rm.type = 'button';
        rm.className = 'cg-garage__remove';
        rm.setAttribute('aria-label', 'Remove ' + label(v));
        rm.textContent = '\u00d7';
        rm.addEventListener('click', function () {
          var gg = getGarage();
          gg.vehicles.splice(i, 1);
          gg.active = 0;
          saveGarage(gg);
        });
        li.appendChild(pick); li.appendChild(rm);
        list.appendChild(li);
      });
    }
    toggle.addEventListener('click', function () {
      var open = list.hidden;
      list.hidden = !open;
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('cg:garage-change', render);
    render();
  }

  /* ---------- product badge ---------- */
  function initBadge(el) {
    var msg = el.querySelector('[data-cg-fit-msg]');
    var btn = el.querySelector('[data-cg-fit-open]');
    var universal = el.getAttribute('data-universal') === 'true';
    var data = [];
    try { data = JSON.parse(el.querySelector('[data-cg-fit-data]').textContent) || []; } catch (e) {}

    function update() {
      var v = activeVehicle();
      el.classList.remove('cg-fit--yes', 'cg-fit--no');
      if (universal) {
        el.classList.add('cg-fit--yes');
        msg.textContent = '\u2713 Universal fit';
        btn.hidden = true;
        return;
      }
      if (!v) {
        msg.textContent = 'Check if this part fits your vehicle.';
        btn.hidden = false;
        return;
      }
      var fits = data.some(function (d) {
        return d.make.toLowerCase() === v.make.toLowerCase() &&
               d.model.toLowerCase() === v.model.toLowerCase() &&
               v.year >= d.from && v.year <= (d.to || d.from);
      });
      el.classList.add(fits ? 'cg-fit--yes' : 'cg-fit--no');
      msg.textContent = (fits ? '\u2713 Fits your ' : '\u2717 Does not fit your ') + label(v);
      btn.hidden = false;
      btn.textContent = 'Change vehicle';
    }
    btn.addEventListener('click', function () {
      var f = document.querySelector('[data-cg-finder]');
      if (!f) return;
      f.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var first = f.querySelector('select:not([disabled])');
      if (first) first.focus();
    });
    document.addEventListener('cg:garage-change', update);
    update();
  }


  /* ---------- product cards: badge + "only parts that fit" ---------- */
  var ONLY_KEY = 'cg_only_fit_v1';
  function cardFits(el, v) {
    if (el.getAttribute('data-universal') === 'true') return true;
    var data = [];
    try { data = JSON.parse(el.textContent) || []; } catch (e) {}
    return data.some(function (d) {
      return String(d[0]).toLowerCase() === v.make.toLowerCase() &&
             String(d[1]).toLowerCase() === v.model.toLowerCase() &&
             v.year >= d[2] && v.year <= (d[3] || d[2]);
    });
  }
  function applyCards() {
    var marks = document.querySelectorAll('[data-cg-card-fit]');
    var toggle = document.querySelector('[data-cg-only]');
    var input = document.querySelector('[data-cg-only-input]');
    var v = activeVehicle();
    if (toggle) toggle.hidden = !(marks.length && v);
    var only = !!(v && input && input.checked);
    Array.prototype.forEach.call(marks, function (m) {
      var card = m.closest('.product-card');
      if (!card) return;
      var badge = card.querySelector('[data-cg-card-badge]');
      var host = card.closest('.halo-item') || card;
      if (!v) { if (badge) badge.hidden = true; host.hidden = false; return; }
      var fits = cardFits(m, v);
      if (badge) {
        badge.hidden = false;
        badge.className = 'cg-card-fit ' + (fits ? 'cg-card-fit--yes' : 'cg-card-fit--no');
        badge.textContent = fits ? '\u2713 Fits' : '\u2717 No fit';
      }
      host.hidden = only && !fits;
    });
  }
  function initCards() {
    var input = document.querySelector('[data-cg-only-input]');
    if (input && !input.hasAttribute('data-bound')) {
      input.setAttribute('data-bound', '1');
      input.checked = readJSON(window.localStorage, ONLY_KEY) === true;
      input.addEventListener('change', function () { writeJSON(window.localStorage, ONLY_KEY, input.checked); applyCards(); });
    }
    applyCards();
  }
  var cardTimer;
  document.addEventListener('cg:garage-change', applyCards);
  if (window.MutationObserver) {
    new MutationObserver(function () { clearTimeout(cardTimer); cardTimer = setTimeout(applyCards, 150); })
      .observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-cg-finder]'), initFinder);
    Array.prototype.forEach.call(document.querySelectorAll('[data-cg-fit]'), initBadge);
    initCards();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
